// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fade-enter-active[data-v-7ba5bd90],\n.fade-leave-active[data-v-7ba5bd90] {\n  -webkit-transition: opacity 0s;\n  transition: opacity 0s;\n}\n.fade-enter[data-v-7ba5bd90],\n.fade-leave-to[data-v-7ba5bd90] {\n  opacity: 0;\n}\n\n", ""]);
// Exports
module.exports = exports;
